<template>    
    <Dialog :visible="visible" modal header="Seleccione el trabajo" :style="{width: '1400px'}"  :closable="false">
        <div class="card card-default card-tabs" style="margin:0">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#general" data-toggle="tab">
                            General
                        </a>
                    </li>
                    <li  class="nav-item" v-if="mostrarFacturacionAxa">
                        <a @click="obtenerAfectados(); console.log('trabajodatos', this.trabajodatos);" class="nav-link" data-toggle="tab" href="#webservice">
                            Web service AXA
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content" ref="tabContents" style=" margin-top: 15px; padding-bottom: 15px;">
            <div class="tab-pane active container-grid" id="general">
                <div v-if="isSaving" class="dialog-overlay">
                    <i class="fas fa-spinner fa-spin"></i> Guardando...
                </div>
                <div v-else style="display: flex; gap: 15px;">
                    <div style="width: 80%;">
                        <!-- Mostrar el spinner si los trabajos estÃ¡n cargando -->
                        <div v-if="isLoading" class="loading-spinner">
                            <i class="fas fa-spinner fa-spin"></i> Cargando trabajos...
                        </div>
                        <Listbox v-model="trabajoSeleccionado" :options="trabajosFiltrados" optionLabel="label" class="w-full md:w-14rem" listStyle="max-height:250px">
                            <template #option="slotProps">
                                <div v-if="this.operario" class="flex align-items-center">                        
                                    <div>{{ slotProps.option.codigo }} {{ slotProps.option.nombre }} [{{ slotProps.option.precio_operario }}€]</div>
                                </div>
                                <div v-else class="flex align-items-center">                        
                                    <div>{{ slotProps.option.codigo }} {{ slotProps.option.nombre }} [{{ slotProps.option.precio }}€]</div>
                                </div>
                            </template>
                        </Listbox>           
                    </div>
                    <div>
                        <input style="flex-grow: 1;" v-model="filtro" type="text" placeholder="Filtrar">     
                    </div>
                </div>
            </div>
            <div class="tab-pane container-grid" id="webservice">
                <!-- Mostrar el spinner si los trabajos estÃ¡n cargando -->                    
                <div v-if="isLoading" class="loading-spinner">
                    <i class="fas fa-spinner fa-spin"></i> Cargando trabajos...
                </div>
                <div v-else-if="isSaving" class="dialog-overlay">
                    <i class="fas fa-spinner fa-spin"></i> Guardando...
                </div>
                <div v-else>
                    <div style="margin: 15px 0; display: grid; gap: 15px; grid-template-columns: 3fr 4fr 2fr 2fr;">                       
                        <select :disabled="!afectadosCargados" v-model="afectadoSeleccionado" class="form-control" id="">
                            <option disabled value="">Seleccione afectado</option>
                            <option v-for="afectado in afectados" :key="afectado.IdAfectado" :value="afectado">{{ afectado.NombreAfectado }}</option>
                        </select>
                        <select :disabled="!oficiosCargados" v-model="oficioSeleccionado" class="form-control" id="">
                            <option disabled value="">Seleccione oficio</option>
                            <option v-for="oficio in oficios" :disabled="oficio.TotalEspecialidad!=''" :key="oficio.IdEspecialidad+'-'+oficio.Indice" :value="oficio">{{ oficio.NombreEspecialidad }} - {{oficio.Estado}}({{ oficio.FechaEstado }}) <span v-if="oficio.TotalEspecialidad">{{ oficio.TotalEspecialidad }}?</span></option>
                        </select>
                        <select :disabled="!presupuestarCargado" v-model="presupuestarSeleccionado" class="form-control" id="">
                            <option disabled value="">Seleccione tipo</option>
                            <option v-for="presupuestar in presupuestarTipos" :key="presupuestar" :value="presupuestar">{{ presupuestar }}</option>
                        </select>
                    </div>
                    <div style="display: flex; gap: 15px;">
                        <!-- LISTADO DE PRESUS/VALS DISPONIBLES PARA EL  AFECTADO, OFICIO Y TIPO SELECCIONADOS -->
                        <div style="width: 80%;">                
                            <Listbox :modelValue="trabajoServiceSeleccionado" @update:modelValue="datosBaremo" :options="trabajosServiceFiltrados" optionLabel="label" class="w-full md:w-14rem" listStyle="max-height:250px">
                                <template #option="slotProps">
                                    <div class="flex align-items-center">                        
                                        <div v-if="slotProps.option.extra==0">{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - min: {{ slotProps.option.min_uds }} - max: {{ slotProps.option.max_uds }}</div>
                                        <div v-else>{{ slotProps.option.nombre_categoria }} - {{ slotProps.option.desc_linea }} [{{ slotProps.option.tipo_linea }}] - extra: {{ slotProps.option.extra }}</div>
                                    </div>
                                </template>
                            </Listbox>           
                        </div>
                        <div style="display: grid; gap: 10px;">
                            <div>
                                <input style="flex-grow: 1;" v-model="filtroService" type="text" placeholder="Filtrar">
                            </div>
                            <div style="display: flex; gap: 10px;">
                                <div style="display: grid;">
                                    <label style="margin: 0;" for="">Unidad</label>
                                    <input class="form-control" v-model="unidad" disabled type="text">
                                </div>
                                <div style="display: grid;">
                                    <label style="margin: 0;" for="">Uds</label>
                                    <input @blur="calcularPrecio" class="form-control" v-model="unidades" :disabled="unidadesDisabled" type="text">
                                </div>
                            </div>
                            <div style="display: flex; gap: 10px;">
                                <div style="display: grid;">
                                    <label style="margin: 0;" for="">Precio</label>
                                    <input class="form-control" @blur="calcularPrecio" v-model="precio" :disabled="precioDisabled" type="number">
                                </div>
                                <div style="display: grid;">
                                    <label style="margin: 0; width: 85px;" for="">IVA(%)</label>
                                    <select class="form-control" v-model="ivaSeleccionado" id="">
                                        <option v-for="iva in ivas" :key="iva" :value="iva">{{ iva }}</option>
                                    </select>
                                </div>
                            </div>
                            <div v-if="minKmFacturablesVisible" style="display: grid;">
                                <label style="margin: 0;" for="">Mí­nimo</label>
                                <input class="form-control" v-model="minKmFacturables" disabled type="text">
                            </div>
                            <div style="display: grid;">
                                <label style="margin: 0;" for="">Descripción</label>
                                <textarea :disabled="comentarioDisabled" v-model="comentario" rows="2" class="form-control" id=""></textarea>
                            </div>
                            <div style="display: flex; justify-content: end;">
                                <Button :disabled="precio==''" label="Agregar" @click="agregarTrabajo()" class="btn-primary" />
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Cancelar" @click="$emit('update:visible', false)" class="btn-default" />
        </template>
        
    </Dialog>
</template>


<script>
import { PwgsApi } from '../../../../../../services/PwgsApi';
import Dialog from 'primevue/dialog';
import Listbox from 'primevue/listbox';
export default {
    props: ['trabajodatos', 'visible', 'operario', 'id', 'servicio'],
    components: {
        Dialog,
        Listbox,
    },
    data() {
        return {
            mostrarFacturacionAxa: false,
            filtroService:'',
            trabajoAEnviar:'',
            unidadesDisabled: false,
            precioDisabled: true,
            comentarioDisabled: true,
            minKmFacturablesVisible: false,
            unidad: '',
            unidades: '',
            precio: '',
            comentario: '',
            trabajoServiceSeleccionado:'',
            ivas:[],
            ivaSeleccionado:'',
            admiteIVAReducido:false,
            trabajosService:[],
            presupuestarTipos:[],
            trabajosTotales:[],
            presupuestarSeleccionado:'',
            presupuestarCargado:false,
            oficioSeleccionado:'',
            oficios:[],
            incrementoImportePorUrgencia:0,
            minKmFacturables:0,
            facturaKm:'N',
            idReparador:'',
            especialidadesValoraciones:[],
            afectadosValoraciones:[],
            oficiosCargados: false,
            afectadosCargados: false,
            afectadoSeleccionado:'',
            afectados:[],
            filtro:'',
            trabajos:[],
            trabajoSeleccionado:'',
            isLoading: false, // Estado para controlar la carga de los trabajos
            isSaving: false,  // Estado para mostrar "loading" al guardar
        };
    },
    mounted() {
        this.comprobarFacturacionAxa();
    },
    computed:{
        trabajosFiltrados(){
            if(this.filtro==''){
                return this.trabajos;
            }else{
                return this.trabajos.filter(t => t.codigo.toLowerCase().includes(this.filtro.toLowerCase())||t.nombre.toLowerCase().includes(this.filtro.toLowerCase()));
            }
        },
        trabajosServiceFiltrados(){
            if(this.filtroService==''){
                return this.trabajosService;
            }else{
                return this.trabajosService.filter(t => t.nombre_categoria.toLowerCase().includes(this.filtroService.toLowerCase())||t.desc_linea.toLowerCase().includes(this.filtroService.toLowerCase()));
            }
        },
    },
    methods: {
        async obtenerBaremos(){            
            const api = new PwgsApi();
            this.trabajosService = [];
            this.trabajosTotales = [];
            this.trabajosTotales = await api.post('servicios/' + this.id + '/baremos',{
                id_especialidad: this.oficioSeleccionado.IdEspecialidad,
                tipo: 'Valoraciones',
                presupuestar: this.presupuestarSeleccionado
            });
            if(!this.trabajosTotales){
                this.trabajosTotales = [];
            }
            //this.trabajosTotales = this.trabajosTotales.filter(t => t.visita == 'S' || t.tipo_linea == 'Desplazamiento');
            if(this.facturaKm!='S'){
                this.trabajosTotales = this.trabajosTotales.filter(t => t.tipo_linea != 'Desplazamiento');
            }
            console.log('trabajosTotales', this.trabajosTotales);
            if(this.presupuestarSeleccionado=='PresupuestarPorMO'){
                const nuevoTrabajo = {};
                nuevoTrabajo.reparador = this.idReparador;
                nuevoTrabajo.id_especialidad = this.oficioSeleccionado.IdEspecialidad;
                nuevoTrabajo.tipo = this.presupuestarSeleccionado;
                nuevoTrabajo.procedencia = 'Valoraciones';
                nuevoTrabajo.id_baremo = 0;
                nuevoTrabajo.id_categoria = 0;
                nuevoTrabajo.nombre_categoria = 'material';
                nuevoTrabajo.clave_linea = 0;
                nuevoTrabajo.id_linea = 0;
                nuevoTrabajo.desc_linea = 'material';
                nuevoTrabajo.desc_unidad = 'UD';
                nuevoTrabajo.id_unidad = 0;
                nuevoTrabajo.extra = 1;
                nuevoTrabajo.min_uds = 0;
                nuevoTrabajo.max_uds = 0;
                nuevoTrabajo.precio = 0;
                nuevoTrabajo.tipo_linea = 'Materiales';
                nuevoTrabajo.visita = 'N';
                nuevoTrabajo.id_tarifa = 0;
                nuevoTrabajo.timestamp = '';
                console.log('nuevoTrabajo', nuevoTrabajo);
                this.trabajosTotales.unshift(nuevoTrabajo);                
            }
            console.log('trabajosTotales2', this.trabajosTotales);


            //QUE HACER CON MATERIALES A MO, YA QUE NO VAN UNIDOS A UN TRABAJO REAL
            // if(this.presupuestarSeleccionado=='PresupuestarPorMO'){
            //     this.trabajosTotales.push({
            //         clave_linea: '0',
            //         desc_linea: 'material',
            //         desc_unidad:'ud',
            //         extra: 0,
            //         id_baremo:0,
            //     })
            // }
            
            console.log('llegatrabs', this.trabajosTotales);
            this.tra
            this.trabajosTotales.forEach(trabajo => {
                if(this.trabajosService.length==0){
                    this.trabajosService.push(trabajo);
                }else{
                    var encontrado = '';
                    encontrado = this.trabajosService.find(t => t.desc_linea == trabajo.desc_linea && t.nombre_categoria == trabajo.nombre_categoria && t.tipo_linea == trabajo.tipo_linea);
                    if(!encontrado){
                        this.trabajosService.push(trabajo);
                    }
                }
            })
            if(this.trabajosService.length>0){
               //
            }else{
                this.trabajoServiceSeleccionado = '';
            }
        },
        calcularPrecio(){
            //ARREGLAR PARA DECIMALES
            var trabajosEncontrados = this.trabajosTotales.filter(t => t.desc_linea == this.trabajoServiceSeleccionado.desc_linea && t.nombre_categoria == this.trabajoServiceSeleccionado.nombre_categoria && t.tipo_linea == this.trabajoServiceSeleccionado.tipo_linea);
            console.log('trabajosEncontrados', trabajosEncontrados);
            if(trabajosEncontrados[0].tipo_linea=="Materiales"){
                this.trabajoAEnviar = trabajosEncontrados[0];
            }else if(trabajosEncontrados[0].tipo_linea=="Desplazamiento"){
                this.trabajoAEnviar = trabajosEncontrados[0];
                var unidadesAFacturar = this.unidades - this.minKmFacturables;
                console.log('unidadesAFacturar', unidadesAFacturar);
                if(unidadesAFacturar>0){
                    var pr = this.trabajoAEnviar.precio * unidadesAFacturar;            
                    this.precio = Number(pr.toFixed(2));
                }
                console.log('precio', this.precio);
            }else{
                if(trabajosEncontrados.length==1){                     
                    var pr2 = this.unidades*trabajosEncontrados[0].precio;
                    this.precio = Number(pr2.toFixed(2));
                    this.trabajoAEnviar = trabajosEncontrados[0];
                }else{
                    var trabajoValido = [];
                    var max = 0;
                    var trabajoMenorMax = '';
                    var menorMax = 0;
                    var trabajoMayorMax = '';
                    var trabajoExtra = '';
                    trabajosEncontrados.forEach(t => {
                        t.precio = parseFloat(t.precio);
                        if(t.extra == '0'){
                            t.min_uds = parseFloat(t.min_uds);
                            t.max_uds = parseFloat(t.max_uds);
                            if(t.max_uds == ',5'){
                                t.max_uds = 0.5;
                            }
                            if(this.unidades>=t.min_uds && this.unidades<=t.max_uds){
                                trabajoValido.push(t);                            
                            }                        
                            if(trabajoMenorMax==''){
                                trabajoMenorMax = t;
                                trabajoMayorMax = t;
                                menorMax = t.max_uds;
                                max = t.max_uds;
                            }else{
                                if(t.max_uds<menorMax){
                                    trabajoMenorMax = t;
                                    menorMax = t.max_uds;
                                }else{
                                    trabajoMayorMax = t;
                                    max = t.max_uds;
                                }
                            }
                        }else{
                            trabajoExtra = t;
                        }
                    })
                    if(max>=this.unidades){
                        if(trabajoValido.length==1){
                            this.precio = trabajoValido[0].precio;
                            this.trabajoAEnviar = trabajoValido[0];
                        }else{
                            this.trabajoAEnviar = trabajoMenorMax;
                            this.precio = trabajoMenorMax.precio;
                        }
                    }else{
                        this.trabajoAEnviar = trabajoMayorMax;
                        var extras = this.unidades-max;
                        var precioExtra = extras*trabajoExtra.precio;
                        var pr3 = trabajoMayorMax.precio+precioExtra;
                        this.precio = Number(pr3.toFixed(2));
                    }
                }
            }
            console.log('trabajoAEnviar', this.trabajoAEnviar);
        },
        async agregarTrabajo(){
            this.isSaving = true;
            if(this.trabajoAEnviar.tipo_linea=="Materiales" && this.comentario == ''){
                alert('Debe indicar una descripción');
                this.isSaving = false;
                return;
            }
            const api = new PwgsApi();
            var temporalesPresu = await api.get('presupuestos/'+ this.trabajodatos.id+ '/presuval-axa');
            console.log('llegaagre');
            console.log('temporalesPresupuestoActual', temporalesPresu);
            console.log('trabajoAEnviar', this.trabajoAEnviar);
            var tipoEnviar = this.trabajoAEnviar.tipo;
            console.log('especialidadEnviar', this.oficioSeleccionado, this.presupuestarSeleccionado);
            var error = '';
            for(let temporal of temporalesPresu){
                if(this.trabajoAEnviar.clave_linea!=0 && temporal.trabajo.clave_linea == this.trabajoAEnviar.clave_linea && temporal.IdEspecialidad == this.oficioSeleccionado.IdEspecialidad && temporal.Indice == this.oficioSeleccionado.Indice && temporal.IdAfectado == this.afectadoSeleccionado.IdAfectado){
                    error = 'Baremo ya añadido a un trabajo.';
                    break;
                }
                if(temporal.trabajo.tipo != tipoEnviar){
                    error = 'La valoración que se está creando es de distinto tipo.'
                    break;
                }
                if(temporal.IdAfectado != this.afectadoSeleccionado.IdAfectado){
                    error = 'La valoración que se está creando es de distinto afectado.'
                }
            }
            if(error != ''){
                alert(error);
                this.isSaving = false;
                return;
            }
            setTimeout(async() => {
                var total = 0;
                var precio = 0;
                if(this.trabajoAEnviar.tipo_linea=="Materiales"){
                    console.log('trabajoAEnviar', this.trabajoAEnviar);
                    this.trabajoAEnviar.precioUnidad = this.precio;
                    precio = this.precio*this.unidades;
                    total = precio+(this.ivaSeleccionado*precio)/100;
                }else if(this.trabajoAEnviar.tipo_linea=="Desplazamiento"){
                    this.trabajoAEnviar.minKmFacturables = this.minKmFacturables;
                    this.trabajoAEnviar.unidadesAFacturar = this.unidades - this.minKmFacturables;
                    precio = this.precio;
                    total = parseFloat(this.precio)+parseFloat(((this.ivaSeleccionado*this.precio)/100));
                    total = parseFloat(total).toFixed(2);                    
                }else{
                    precio = this.precio;
                    total = this.precio+(this.ivaSeleccionado*this.precio)/100;
                }
                if(this.oficioSeleccionado.TotalEspecialidad!=''){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El oficio ya se encuentra presupuestado', life: 2000 });
                }else{
                    try{
                        console.log('trabajoAEnviar', this.trabajoAEnviar);
                        
                        var body = {
                            "TipoOperacion"     : "MANAGE_PREVAL",
                            "Enviado"           : "N",
                            "Facturado"         : "N",
                            "TipoPrepVal"       : 'V',
                            "IdAfectado"        : this.afectadoSeleccionado.IdAfectado,
                            "PresupuestarPor"   : this.presupuestarSeleccionado == 'PresupuestarPorMO'?'MO':'BA',
                            "IdEspecialidad"    : this.oficioSeleccionado.IdEspecialidad,
                            "Indice"            : this.oficioSeleccionado.Indice,
                            "IvaSeleccionado"   : this.ivaSeleccionado,
                            "Descripcion"       : this.comentario,
                            "IvaReducido"       : this.admiteIVAReducido?'S':'N',                        
                            "IVAOfic"           : this.ivas[0],
                            "trabajo"           : this.trabajoAEnviar,
                            "Cantidad"          : this.unidades,
                            "Urgente"           : 'N',
                            "TotalSinIva"       : precio,
                            "TotalConIva"       : total,
                        }
                        console.log(body);

                        await api.put('presupuestos/' + this.trabajodatos.idtrabajo_presupuesto + '/modificar-trabajo', { baremos_trabajos_axa: 1 
                            ,iva: this.ivaSeleccionado,codigo: this.trabajoAEnviar.clave_linea, nombre: this.trabajoAEnviar.desc_linea, datos: body});
                        this.$emit('update:visible', false)
                        console.log('trabajodatosasas', this.trabajodatos, this.operario);
                        this.$emit('actualizarconcepto', this.trabajodatos.idtrabajo_presupuesto);
                        // if(this.trabajodatos.destinatario_trabajo == "" || this.trabajodatos.destinatario_trabajo == "CompaÃ±ia"){
                        //     console.log('trabajodatosasas1');
                        //     this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'cliente');
                        // }else{
                        //     console.log('trabajodatosasas2', this.trabajodatos.destinatario_trabajo);
                        //     this.$parent.$parent.$parent.togglerecargar(this.trabajodatos, true, false, 'opera');
                        // }
                        this.$parent.$parent.cargartrabajospresupuesto();
                        this.isSaving = false;
                        this.$toast.add({severity:'success', summary: 'Agregado', detail: 'Trabajo Agregado', life: 2000});
                    }catch(e){
                        this.isSaving = false;
                        this.$toast.add({severity:'error', summary: 'Error', detail: e, life: 5000});
                    }
                }
            },1000)
        },
        datosBaremo(valor){
            if(valor === this.trabajoServiceSeleccionado){
                return;
            }
            if(valor.visita != 'S' && valor.tipo_linea != 'Desplazamiento'){
                this.ivas = [0];
                this.ivaSeleccionado = 0;
            }else{
                this.ivas = this.oficioSeleccionado.IVAS[0].IVA;
                this.ivaSeleccionado = this.ivas[0];
            }
            this.trabajoServiceSeleccionado = valor;
            console.log('trabajo', this.trabajoServiceSeleccionado);
            this.unidad = this.trabajoServiceSeleccionado.desc_unidad.toLowerCase();
            this.unidades = '';
            this.precio = '';
            this.comentario = '';
            if(this.trabajoServiceSeleccionado.tipo_linea == 'MO'){
                this.unidadesDisabled = false;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
                this.minKmFacturablesVisible = false;
            }else if(this.trabajoServiceSeleccionado.tipo_linea == 'Desplazamiento'){
                this.unidadesDisabled = false;
                this.minKmFacturablesVisible = true;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
            }else if(this.trabajoServiceSeleccionado.tipo_linea == "Baremo"){
                this.unidadesDisabled = false;
                this.precioDisabled = true;
                this.comentarioDisabled = true;
                this.minKmFacturablesVisible = false;
            } else{
                this.unidadesDisabled = false;
                this.precioDisabled = false;
                this.comentarioDisabled = false;
                this.minKmFacturablesVisible = false;
            }

        },
        comprobarOficio(){
            this.presupuestarCargado = false;
            this.presupuestarSeleccionado = '';
            setTimeout(() => {
                this.presupuestarTipos = [];
            
                if(this.oficioSeleccionado.AdmitePresupuestarMO=='S'){
                    this.presupuestarTipos.push('PresupuestarPorMO');                
                }
                if(this.oficioSeleccionado.AdmitePresupuestarBA=='S'){
                    this.presupuestarTipos.push('PresupuestarPorBaremo');
                    this.presupuestarSeleccionado = 'PresupuestarPorBaremo';
                }else{
                    this.presupuestarSeleccionado = 'PresupuestarPorMO';
                }
            
                if(this.oficioSeleccionado.AdmiteIVAReducido=='S'){
                    this.admiteIVAReducido = true;
                }else{
                    this.admiteIVAReducido = false;
                }
                console.log('oficioselec',this.oficioSeleccionado);
                this.ivas = this.oficioSeleccionado.IVAS[0].IVA;
                this.ivaSeleccionado = this.ivas[0];
                this.presupuestarCargado = true;
            }, 100);            
        },
        async cargarTrabajos(){
            const api = new PwgsApi();
            this.isLoading = true; // Iniciar el indicador de carga
            try {
                let subidadatos = { id_especialidad: this.trabajodatos.especialidades_idespecialidad };
                this.trabajos = await api.post('servicios/' + this.$props.id + '/baremo', subidadatos);
                console.log('servicio', this.servicio);
            } catch (error) {
                alert('Error al cargar los trabajos');            
            }
            this.isLoading = false; // Finalizar el indicador de carga
        },
        async guardar(){
            const api = new PwgsApi();
            this.isSaving = true;  
            try {
                let subidadatos = { codigo: this.trabajoSeleccionado.codigo, id_baremo: this.trabajoSeleccionado.idtrabajo, nombre: this.trabajoSeleccionado.nombre,
                    precio: this.trabajoSeleccionado.precio, precio_operario: this.trabajoSeleccionado.precio_operario, 
                    cantidad: 1,destinatario: this.trabajoSeleccionado.destinatario}
                await api.put('presupuestos/' + this.trabajodatos.idtrabajo_presupuesto + '/modificar-trabajo', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                this.$emit('update:visible', false)

                this.$emit('actualizarconcepto', this.trabajodatos.idtrabajo_presupuesto);
                this.$parent.$parent.cargartrabajospresupuesto();
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }   finally {
                this.isSaving = false;  // Detener el indicador de guardado
            }
        },
        async obtenerAfectados(){
            this.afectadosCargados = false;
            this.oficiosCargados = false;
            var proce = 'V';            
            const api = new PwgsApi();
            console.log('trabajodatos', this.trabajodatos);
            try{
                this.isLoading = true;
                var datos = await api.post('servicios/' + this.trabajodatos.servicios_idservicios + '/oficios', {procedencia: proce});                
                if(datos.RepairEstimateValuationList){
                    console.log('entradatosencargo', datos);
                    this.afectadosValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado;
                    this.especialidadesValoraciones = datos.RepairEstimateValuationList.Valoraciones.OficiosAfectado[0].Afectado[0].Especialidades;
                }
                if(datos.DatosReparador){
                    this.facturaKm = datos.DatosReparador.FacturaKm;
                    this.minKmFacturables = datos.DatosReparador.MinKmFacturables;
                    this.idReparador = datos.DatosReparador.IdReparador;
                    console.log('entradatosrepara', this.minKmFacturables, datos.DatosReparador.MinKmFacturables);
                    this.incrementoImportePorUrgencia = datos.DatosReparador.IncrementoImportePorUrgencia;
                }
                this.afectados = datos.RepairEstimateValuationList['Valoraciones'].OficiosAfectado[0].Afectado;
                this.isLoading = false;
                this.afectadoSeleccionado = this.afectados[0];
                this.afectadosCargados = true;
                this.obtenerOficios();
            }catch(e){
                console.log('error', e);
            }
        },
        async obtenerOficios(){
            this.oficios = this.afectadoSeleccionado.Especialidades;
            console.log('llgaobteneroficios', this.oficios);
            this.oficiosCargados = true;
        },
        async comprobarFacturacionAxa(){
            if(this.servicio && this.servicio.compania.sistema=='AXA_WS'){
                const api = new PwgsApi();
                var facturacionAxa = await api.get('parametros-pwgs/axa_facturacion');
                if(facturacionAxa.axa_facturacion == 1){
                    this.mostrarFacturacionAxa = true;
                }
            }
        },
    },
    watch: {
        // trabajoServiceSeleccionado(){
        //     this.datosBaremo();
        // },
        presupuestarSeleccionado(newVal){
            if(newVal!=''){
                this.obtenerBaremos();
            }
        },
        oficioSeleccionado(){
            this.trabajosService = [];
            if(this.oficioSeleccionado==''){
                this.presupuestarCargado = false;
                this.presupuestarSeleccionado = '';
            }else{
                this.comprobarOficio();
            }
        },
        afectadoSeleccionado(){
            this.obtenerOficios();
        },
        visible(newVal) {
            //this.localVisible = newVal;
            if (newVal) {
                // Cargar los trabajos cuando el modal se haga visible
                this.cargarTrabajos();
            }
        },
        trabajoSeleccionado(){
            this.guardar();
        }
    },
};
</script>

<style scoped>
.loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: #333;
    margin-top: 20px;
}
</style>